import React from 'react';
import { Text } from 'react-native';
import TipTitle from './TipTitle';
import TipsStyle from './style';
import { TipLayout } from './TipTypes';
const TEXT_STYLE = new TipsStyle(false);
export default class TipText extends React.PureComponent {
    render() {
        const { title, layoutType, numberOfLines, text, contentColor, customStyle, textStyle, needScale } = this.props;
        TEXT_STYLE.setIsScale(needScale);
        let styles = TEXT_STYLE.getStyle();
        return (<Text style={[
            styles.text,
            customStyle === null || customStyle === void 0 ? void 0 : customStyle.textStyle,
            { color: customStyle === null || customStyle === void 0 ? void 0 : customStyle.textColor },
            layoutType === TipLayout.CENTER_LAYOUT
                ? { textAlign: 'center' }
                : null
        ]} numberOfLines={numberOfLines}>
                {layoutType === TipLayout.HORIZONTAL_LAYOUT && title ? (<TipTitle customStyle={customStyle} layoutType={layoutType} text={title}/>) : null}
                <Text style={[{ color: contentColor }, textStyle]}>{text}</Text>
            </Text>);
    }
}
